import {useParams} from 'react-router-dom'
import ConnectorViewMappingStore, {ConnectorViewMappingContext,} from '../context/context'
import {useContext, useEffect, useState} from 'react'
import { useIntl } from 'react-intl'
import {NavContext} from '../../../../context/global_context'
import {getRequest} from '../../../../services/base'
import {getRandomString} from '../../../../utils/common'
import {notifyError} from '../../../../utils/notifications'
import ConnectorImage from '../ConnectorImage'
import {RightPanelSkeleton} from '../MappingSkeleton'
import {PrinterOutlined} from '@ant-design/icons'
import {Button, Modal, Result, Space} from 'antd'

const ConnectorMappingPrint = () => {
  const intl = useIntl();
  const { vehicle, connector_view } = useParams()
  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const [, navDispatch] = useContext(NavContext)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [modal, contextHolder] = Modal.useModal()

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({id: 'layout.adminTools'}),
        sub_header: `${intl.formatMessage({ id: 'layout.vehicleList' })} / ${vehicle} / ${intl.formatMessage({ id: 'sidebar.vehicleViews' })} / ${intl.formatMessage({ id: 'connectorViews.mapping.connectorMapping' })}`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        back_btn_url: `/vehicles/${vehicle}/connector_views/`,
        full_width_container: true,
      },
    })
    getConnectorViewData()
  }, [])

  const getConnectorViewData = async () => {
    setLoading(true)
    try {
      let res = await getRequest(`/api/connector_views/${connector_view}/`)
      if (!res?.status) {
        setError(true)
        return
      }
      dispatch({
        type: 'connector_view',
        data: { ...res, svg: `${res?.svg}?string=${getRandomString()}` },
      })
      await getConnectorsData()
    } catch (e) {
      notifyError(navDispatch, intl.formatMessage({id: 'connectorViews.print.loadViewFailed'}))
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const getConnectorsData = async () => {
    try {
      let res = await getRequest(
        `/api/connector_views/connectors/${connector_view}/`
      )
      // base.js no longer rejects on a failed request, so the catch below only
      // sees genuine programming errors - the failure branch has to be explicit.
      if (res?.status === false) {
        notifyError(navDispatch, intl.formatMessage({id: 'connectorViews.print.loadConnectorsFailed'}))
        return
      }
      let tempMappedConnectors =
        res?.data?.length > 0 ? res.data.filter((ctr) => ctr.auto_mapped) : []
      formatMappedReferences(tempMappedConnectors)
    } catch (e) {
      notifyError(navDispatch, intl.formatMessage({id: 'connectorViews.print.loadConnectorsFailed'}))
    }
  }

  const formatMappedReferences = (data) => {
    let tempMappedReferences = {}
    data.forEach((row) => {
      if (row.auto_mapped in tempMappedReferences) {
        tempMappedReferences[row.auto_mapped].push(row.name)
      } else {
        tempMappedReferences[row.auto_mapped] = [row.name]
      }
    })
    dispatch({ type: 'mappedReferences', data: tempMappedReferences })
  }

  const handlePrint = () => {
    document.title = state.connector_view?.name || intl.formatMessage({id: 'connectorViews.print.connectorView'})
    window.print()
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  const handleClose = () => {
    modal.confirm({
      title: intl.formatMessage({id: 'connectorViews.print.confirmTitle'}),
      content: intl.formatMessage({id: 'connectorViews.print.closeConfirm'}),
      onOk: () => {
        window.close()
      },
    })
  }

  const toggleDisplayConnector = () => {
    dispatch({ type: 'displayConnector', data: !state.displayConnector })
  }

  if (error) {
    return (
      <Result
        status="404"
        title={intl.formatMessage({id: 'connectorViews.print.notFound'})}
        subTitle={intl.formatMessage({id: 'connectorViews.print.notFoundSubtitle'})}
      />
    )
  }

  return (
    <>
      {contextHolder}
      <div className="noPrint connector-mapping-print-navbar">
        <Space size="middle">
          <Button
            onClick={toggleDisplayConnector}
            data-testid="vv-print-toggle-connectors"
          >
            {state.displayConnector ? intl.formatMessage({id: 'connectorViews.print.hideConnectors'}) : intl.formatMessage({id: 'connectorViews.print.showConnectors'})}
          </Button>
          <Button
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            data-testid="vv-print-print"
          >
            {intl.formatMessage({id: 'connectorViews.print.print'})}
          </Button>
          <Button
            onClick={handleRefresh}
            data-testid="vv-print-refresh"
          >
            {intl.formatMessage({id: 'connectorViews.print.refresh'})}
          </Button>
          <Button
            danger
            onClick={handleClose}
            data-testid="vv-print-close"
          >
            {intl.formatMessage({id: 'connectorViews.print.close'})}
          </Button>
        </Space>
      </div>

      {loading ? (
        <div
          className="connector-mapping-page"
          style={{ height: '100vh' }}
        >
          <div className="connector-mapping-print-container">
            <RightPanelSkeleton />
          </div>
        </div>
      ) : (
        <div
          className="connector-mapping-page"
          style={{ height: '100vh' }}
        >
          <div className="connector-mapping-container">
            <ConnectorImage isPrint={true} />
          </div>
        </div>
      )}
    </>
  )
}

const ConnectorViewMappingPrint = () => {
  return (
    <ConnectorViewMappingStore>
      <ConnectorMappingPrint />
    </ConnectorViewMappingStore>
  )
}

export default ConnectorViewMappingPrint
